<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <coming-soon></coming-soon>
    </b-col>
</template>

<script>
    import ComingSoon from './../common/ComingSoon.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'
    
    export default {
        components: { ComingSoon, FuturocoinsFromMining }
    }
</script>

<style lang="scss" scoped>
    .space{
        margin-bottom: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/SponsorSystemContent.vue